import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { Iuser } from '../shared/user';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  private jwtToken: any;

  private decodeToken(): any {
    if (this.jwtToken) {
      try {
        return jwtDecode(this.jwtToken);
      } catch (error) {
        console.log('Error decoding JWT token', error);
        return null;
      }
    }
  }

  setToken(token: any) {
    if (token) {
      localStorage.setItem('token', token);
      this.jwtToken = token;
    }
  }

  getUser(): Iuser | null {
    return this.decodeToken();
  }
}
